import React, { FC } from 'react';
import { Grid, GridOwnProps } from '@mui/material';
import { WithStyles, withStyles } from '@mui/styles';

// Icons
import { APIcon, SMSIcon, DSIcon } from 'components/icons/icons';
import IconPhoneOptIn from 'components/icons/IconPhoneOptIn';
import { NeedInterpreterIcon } from 'containers/patient/patient-overview/components/need-interpreter-icon';
import { ILanguage } from 'interfaces/redux/ILanguage';
import { MedSyncStatusIcon } from 'containers/patient/med-sync/components/medSyncIcon';
import { IPhone } from 'interfaces/redux/IPhone';
import { useTypedSelector } from 'hooks/use-typed-selector';
import { styles } from './display-only-bar.style';
import DisplayOnlyItem from './display-only-item';

interface DisplayOnlyProps extends WithStyles<typeof styles>, Omit<GridOwnProps, 'classes'> {
  adherencePackaging?: boolean;
  needsInterpreter?: boolean;
  medSync?: boolean;
  enrolledInSMS?: boolean;
  notEnrolledInSMS?: boolean;
  dropShipMed?: boolean;
  phones: IPhone[];
  patientAutoFCStatus: number;
  languages?: ILanguage[];
}

const DisplayOnlyBar: React.FC<DisplayOnlyProps> = ({
  classes,
  adherencePackaging,
  needsInterpreter,
  medSync,
  enrolledInSMS,
  dropShipMed,
  phones,
  patientAutoFCStatus,
  notEnrolledInSMS,
  languages,
  ...props
}) => {
  const { sourceNumber } = useTypedSelector(state => state.lookups);

  return (
    <Grid {...props}>
      {adherencePackaging && (
        <DisplayOnlyItem
          title="Adherence Packaging"
          className={classes.adherencePackaging}
          Icon={APIcon}
        />
      )}
      {needsInterpreter && <NeedInterpreterIcon languages={languages} />}
      {medSync && (
        <DisplayOnlyItem
          title="Med Sync"
          className={classes.medSync}
          Icon={MedSyncStatusIcon as FC}
        />
      )}
      {enrolledInSMS && (
        <DisplayOnlyItem title="Enrolled in SMS" className={classes.enrolledInSMS} Icon={SMSIcon} />
      )}
      {notEnrolledInSMS && (
        <DisplayOnlyItem
          title="Not Enrolled in SMS"
          className={classes.enrolledInSMS}
          Icon={SMSIcon}
        />
      )}
      <IconPhoneOptIn
        phones={Array.isArray(phones) ? phones : []}
        sourceNumber={sourceNumber}
        patientAutoFCStatus={patientAutoFCStatus}
      />
      {dropShipMed && (
        <DisplayOnlyItem title="Drop-Ship Med" className={classes.dropShipMed} Icon={DSIcon} />
      )}
    </Grid>
  );
};

export default withStyles(styles)(DisplayOnlyBar);
